import { defineStore, acceptHMRUpdate } from 'pinia'

export const translationStore = defineStore('translationStore', {
  state: () => {
    return {
      appTranslations: {}
    }
  },
  actions: {
    setAppTranslation(translations) {
      this.appTranslations = translations
    }
  },
  getters: {
    getTranslation: state => {
      return locale => state.appTranslations[locale]
    }
  }
})

if (import.meta.hot) {
  import.meta.hot.accept(acceptHMRUpdate(translationStore, import.meta.hot))
}
